// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/bell-off.js';

import { paths } from '../generated/bell-off';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('bell-off', Original, paths);
